/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
'use strict';

function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }

function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) { ; } } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }

function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }

function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }

function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) { n[e] = r[e]; } return n; }

var k = require("lexical"),
    t = require("@lexical/code"),
    A = require("@lexical/list"),
    B = require("@lexical/rich-text"),
    aa = require("@lexical/utils"),
    G = require("@lexical/link");

function H(a, b) {
  var c = {};

  var _iterator = _createForOfIteratorHelper(a),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var d = _step.value;
      a = b(d), c[a] ? c[a].push(d) : c[a] = [d];
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return c;
}

function I(a) {
  a = H(a, function (b) {
    return b.type;
  });
  return {
    element: a.element || [],
    textFormat: a["text-format"] || [],
    textMatch: a["text-match"] || []
  };
}

var J = /[!-/:-@[-`{-~\s]/;

function ba(a) {
  var b = I(a),
      c = b.textFormat.filter(function (d) {
    return 1 === d.format.length;
  });
  return function (d) {
    var e = [];
    d = (d || k.$getRoot()).getChildren();

    var _iterator2 = _createForOfIteratorHelper(d),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var f = _step2.value;
        d = ca(f, b.element, c, b.textMatch), null != d && e.push(d);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }

    return e.join("\n\n");
  };
}

function ca(a, b, c, d) {
  var _iterator3 = _createForOfIteratorHelper(b),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var e = _step3.value;
      if (b = e.export(a, function (f) {
        return K(f, c, d);
      }), null != b) return b;
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return k.$isElementNode(a) ? K(a, c, d) : k.$isDecoratorNode(a) ? a.getTextContent() : null;
}

function K(a, b, c) {
  var d = [];
  a = a.getChildren();

  var _iterator4 = _createForOfIteratorHelper(a),
      _step4;

  try {
    a: for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var e = _step4.value;

      var _iterator5 = _createForOfIteratorHelper(c),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var f = _step5.value;

          if (a = f.export(e, function (g) {
            return K(g, b, c);
          }, function (g, l) {
            return L(g, l, b);
          }), null != a) {
            d.push(a);
            continue a;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }

      k.$isLineBreakNode(e) ? d.push("\n") : k.$isTextNode(e) ? d.push(L(e, e.getTextContent(), b)) : k.$isElementNode(e) ? d.push(K(e, b, c)) : k.$isDecoratorNode(e) && d.push(e.getTextContent());
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return d.join("");
}

function L(a, b, c) {
  var d = b.trim(),
      e = d,
      f = new Set();

  var _iterator6 = _createForOfIteratorHelper(c),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var l = _step6.value;
      c = l.format[0];
      var p = l.tag;

      if (M(a, c) && !f.has(c)) {
        f.add(c);
        var g = N(a, !0);
        M(g, c) || (e = p + e);
        g = N(a, !1);
        M(g, c) || (e += p);
      }
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return b.replace(d, e);
}

function N(a, b) {
  var c = b ? a.getPreviousSibling() : a.getNextSibling();
  c || (a = a.getParentOrThrow(), a.isInline() && (c = b ? a.getPreviousSibling() : a.getNextSibling()));

  for (; c;) {
    if (k.$isElementNode(c)) {
      if (!c.isInline()) break;
      a = b ? c.getLastDescendant() : c.getFirstDescendant();
      if (k.$isTextNode(a)) return a;
      c = b ? c.getPreviousSibling() : c.getNextSibling();
    }

    if (k.$isTextNode(c)) return c;
    if (!k.$isElementNode(c)) break;
  }

  return null;
}

function M(a, b) {
  return k.$isTextNode(a) && a.hasFormat(b);
}

var O = "undefined" !== typeof window && "undefined" !== typeof window.document && "undefined" !== typeof window.document.createElement,
    da = O && "documentMode" in document ? document.documentMode : null;
O && /Mac|iPod|iPhone|iPad/.test(navigator.platform);
O && /^(?!.*Seamonkey)(?=.*Firefox).*/i.test(navigator.userAgent);
O && "InputEvent" in window && !da ? "getTargetRanges" in new window.InputEvent("input") : !1;
var P = O && /Version\/[\d.]+.*Safari/.test(navigator.userAgent),
    Q = O && /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
    ea = O && /^(?=.*Chrome).*/i.test(navigator.userAgent),
    R = O && /AppleWebKit\/[\d.]+/.test(navigator.userAgent) && !ea,
    fa = /^\s{0,3}$/,
    S = /^```(\w{1,10})?\s?$/;

function ha(a) {
  var b = I(a),
      c = ia(b.textFormat);
  return function (d, e) {
    d = d.split("\n");
    var f = d.length;
    e = e || k.$getRoot();
    e.clear();

    for (var h = 0; h < f; h++) {
      var g = d[h];

      a: {
        var l = d,
            p = h;
        var r = e;
        var y = l[p].match(S);
        if (y) for (var q = p, m = l.length; ++q < m;) {
          if (l[q].match(S)) {
            y = t.$createCodeNode(y[1]);
            l = k.$createTextNode(l.slice(p + 1, q).join("\n"));
            y.append(l);
            r.append(y);
            r = [y, q];
            break a;
          }
        }
        r = [null, p];
      }

      var _r = r,
          _r2 = _slicedToArray(_r, 2),
          n = _r2[0],
          v = _r2[1];

      if (null != n) h = v;else {
        r = g;
        m = e;
        var w = b.element;
        q = c;
        l = b.textMatch;
        p = r.trim();
        y = k.$createTextNode(p);
        g = k.$createParagraphNode();
        g.append(y);
        m.append(g);

        var _iterator7 = _createForOfIteratorHelper(w),
            _step7;

        try {
          for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
            var _ref2 = _step7.value;
            var x = _ref2.regExp;
            var u = _ref2.replace;

            if (m = r.match(x)) {
              y.setTextContent(r.slice(m[0].length));
              u(g, [y], m, !0);
              break;
            }
          }
        } catch (err) {
          _iterator7.e(err);
        } finally {
          _iterator7.f();
        }

        T(y, q, l);
        g.isAttached() && 0 < p.length && (r = g.getPreviousSibling(), k.$isParagraphNode(r) || B.$isQuoteNode(r) || A.$isListNode(r)) && (q = r, A.$isListNode(r) && (r = r.getLastDescendant(), q = null == r ? null : aa.$findMatchingParent(r, A.$isListItemNode)), null != q && 0 < q.getTextContentSize() && (q.splice(q.getChildrenSize(), 0, [k.$createLineBreakNode()].concat(_toConsumableArray(g.getChildren()))), g.remove()));
      }
    }

    d = e.getChildren();

    var _iterator8 = _createForOfIteratorHelper(d),
        _step8;

    try {
      for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
        var _h = _step8.value;
        d = _h, k.$isParagraphNode(d) ? (f = d.getFirstChild(), d = null == f || 1 === d.getChildrenSize() && k.$isTextNode(f) && fa.test(f.getTextContent())) : d = !1, d && _h.remove();
      }
    } catch (err) {
      _iterator8.e(err);
    } finally {
      _iterator8.f();
    }

    null !== k.$getSelection() && e.selectEnd();
  };
}

function T(a, b, c) {
  var d = a.getTextContent();
  var e = ja(d, b);

  if (e) {
    var f, g;
    if (e[0] === d) var l = a;else {
      var _a$splitText, _a$splitText2, _a$splitText3, _a$splitText4;

      d = e.index || 0;
      var p = d + e[0].length;
      0 === d ? (_a$splitText = a.splitText(p), _a$splitText2 = _slicedToArray(_a$splitText, 2), l = _a$splitText2[0], f = _a$splitText2[1], _a$splitText) : (_a$splitText3 = a.splitText(d, p), _a$splitText4 = _slicedToArray(_a$splitText3, 3), g = _a$splitText4[0], l = _a$splitText4[1], f = _a$splitText4[2], _a$splitText3);
    }
    l.setTextContent(e[2]);

    if (a = b.transformersByTag[e[1]]) {
      var _iterator9 = _createForOfIteratorHelper(a.format),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var _p = _step9.value;
          l.hasFormat(_p) || l.toggleFormat(_p);
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }

    l.hasFormat("code") || T(l, b, c);
    g && T(g, b, c);
    f && T(f, b, c);
  } else U(a, c);
}

function U(a, b) {
  a: for (; a;) {
    var _iterator10 = _createForOfIteratorHelper(b),
        _step10;

    try {
      for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
        var _a$splitText5, _a$splitText6, _a$splitText7, _a$splitText8;

        var c = _step10.value;
        var d = a.getTextContent().match(c.importRegExp);
        if (!d) continue;
        var e = d.index || 0,
            f = e + d[0].length,
            g = void 0,
            l = void 0,
            p = void 0;
        0 === e ? (_a$splitText5 = a.splitText(f), _a$splitText6 = _slicedToArray(_a$splitText5, 2), g = _a$splitText6[0], a = _a$splitText6[1], _a$splitText5) : (_a$splitText7 = a.splitText(e, f), _a$splitText8 = _slicedToArray(_a$splitText7, 3), l = _a$splitText8[0], g = _a$splitText8[1], p = _a$splitText8[2], _a$splitText7);
        l && U(l, b);
        p && (a = p);
        c.replace(g, d);
        continue a;
      }
    } catch (err) {
      _iterator10.e(err);
    } finally {
      _iterator10.f();
    }

    break;
  }
}

function ja(a, b) {
  var c = a.match(b.openTagsRegExp);
  if (null == c) return null;

  var _iterator11 = _createForOfIteratorHelper(c),
      _step11;

  try {
    for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
      var f = _step11.value;
      var d = f.replace(/^\s/, "");
      c = b.fullMatchRegExpByTag[d];

      if (null != c && (c = a.match(c), d = b.transformersByTag[d], null != c && null != d)) {
        if (!1 !== d.intraword) return c;
        var _c = c,
            _c$index = _c.index,
            e = _c$index === void 0 ? 0 : _c$index;
        d = a[e - 1];
        e = a[e + c[0].length];
        if (!(d && !J.test(d) || e && !J.test(e))) return c;
      }
    }
  } catch (err) {
    _iterator11.e(err);
  } finally {
    _iterator11.f();
  }

  return null;
}

function ia(a) {
  var b = {},
      c = {},
      d = [];

  var _iterator12 = _createForOfIteratorHelper(a),
      _step12;

  try {
    for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
      var e = _step12.value;
      a = e.tag;
      b[a] = e;
      var f = a.replace(/(\*|\^|\+)/g, "\\$1");
      d.push(f);
      c[a] = P || Q || R ? new RegExp("(".concat(f, ")(?![").concat(f, "\\s])(.*?[^").concat(f, "\\s])").concat(f, "(?!").concat(f, ")")) : new RegExp("(?<![\\\\".concat(f, "])(").concat(f, ")((\\\\").concat(f, ")?.*?[^").concat(f, "\\s](\\\\").concat(f, ")?)((?<!\\\\)|(?<=\\\\\\\\))(").concat(f, ")(?![\\\\").concat(f, "])"));
    }
  } catch (err) {
    _iterator12.e(err);
  } finally {
    _iterator12.f();
  }

  return {
    fullMatchRegExpByTag: c,
    openTagsRegExp: new RegExp((P || Q || R ? "" : "(?<![\\\\])") + "(" + d.join("|") + ")", "g"),
    transformersByTag: b
  };
}

function V(a, b, c) {
  var d = c.length;

  for (; b >= d; b--) {
    var e = b - d;
    if (W(a, e, c, 0, d) && " " !== a[e + d]) return e;
  }

  return -1;
}

function W(a, b, c, d, e) {
  for (var f = 0; f < e; f++) {
    if (a[b + f] !== c[d + f]) return !1;
  }

  return !0;
}

var ka = function ka(a) {
  return function (b, c, d) {
    var _d;

    d = a(d);

    (_d = d).append.apply(_d, _toConsumableArray(c));

    b.replace(d);
    d.select(0, 0);
  };
},
    X = function X(a) {
  return function (b, c, d) {
    var e = b.getPreviousSibling(),
        f = b.getNextSibling();
    var g = A.$createListItemNode("check" === a ? "x" === d[3] : void 0);
    A.$isListNode(f) && f.getListType() === a ? (e = f.getFirstChild(), null !== e ? e.insertBefore(g) : f.append(g), b.remove()) : A.$isListNode(e) && e.getListType() === a ? (e.append(g), b.remove()) : (f = A.$createListNode(a, "number" === a ? Number(d[2]) : void 0), f.append(g), b.replace(f));
    g.append.apply(g, _toConsumableArray(c));
    g.select(0, 0);
    (b = Math.floor(d[1].length / 4)) && g.setIndent(b);
  };
},
    Y = function Y(a, b, c) {
  var d = [];
  var e = a.getChildren();
  var f = 0;

  var _iterator13 = _createForOfIteratorHelper(e),
      _step13;

  try {
    for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
      var l = _step13.value;

      if (A.$isListItemNode(l)) {
        if (1 === l.getChildrenSize() && (e = l.getFirstChild(), A.$isListNode(e))) {
          d.push(Y(e, b, c + 1));
          continue;
        }

        e = " ".repeat(4 * c);
        var g = a.getListType();
        g = "number" === g ? "".concat(a.getStart() + f, ". ") : "check" === g ? "- [".concat(l.getChecked() ? "x" : " ", "] ") : "- ";
        d.push(e + g + b(l));
        f++;
      }
    }
  } catch (err) {
    _iterator13.e(err);
  } finally {
    _iterator13.f();
  }

  return d.join("\n");
},
    la = {
  dependencies: [B.HeadingNode],
  export: function _export(a, b) {
    if (!B.$isHeadingNode(a)) return null;
    var c = Number(a.getTag().slice(1));
    return "#".repeat(c) + " " + b(a);
  },
  regExp: /^(#{1,6})\s/,
  replace: ka(function (a) {
    return B.$createHeadingNode("h" + a[1].length);
  }),
  type: "element"
},
    ma = {
  dependencies: [B.QuoteNode],
  export: function _export(a, b) {
    if (!B.$isQuoteNode(a)) return null;
    a = b(a).split("\n");
    b = [];

    var _iterator14 = _createForOfIteratorHelper(a),
        _step14;

    try {
      for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
        var c = _step14.value;
        b.push("> " + c);
      }
    } catch (err) {
      _iterator14.e(err);
    } finally {
      _iterator14.f();
    }

    return b.join("\n");
  },
  regExp: /^>\s/,
  replace: function replace(a, b, c, d) {
    var _c2;

    if (d && (c = a.getPreviousSibling(), B.$isQuoteNode(c))) {
      c.splice(c.getChildrenSize(), 0, [k.$createLineBreakNode()].concat(_toConsumableArray(b)));
      c.select(0, 0);
      a.remove();
      return;
    }

    c = B.$createQuoteNode();

    (_c2 = c).append.apply(_c2, _toConsumableArray(b));

    a.replace(c);
    c.select(0, 0);
  },
  type: "element"
},
    na = {
  dependencies: [t.CodeNode],
  export: function _export(a) {
    if (!t.$isCodeNode(a)) return null;
    var b = a.getTextContent();
    return "```" + (a.getLanguage() || "") + (b ? "\n" + b : "") + "\n```";
  },
  regExp: /^```(\w{1,10})?\s/,
  replace: ka(function (a) {
    return t.$createCodeNode(a ? a[1] : void 0);
  }),
  type: "element"
},
    oa = {
  dependencies: [A.ListNode, A.ListItemNode],
  export: function _export(a, b) {
    return A.$isListNode(a) ? Y(a, b, 0) : null;
  },
  regExp: /^(\s*)[-*+]\s/,
  replace: X("bullet"),
  type: "element"
},
    pa = {
  dependencies: [A.ListNode, A.ListItemNode],
  export: function _export(a, b) {
    return A.$isListNode(a) ? Y(a, b, 0) : null;
  },
  regExp: /^(\s*)(?:-\s)?\s?(\[(\s|x)?\])\s/i,
  replace: X("check"),
  type: "element"
},
    qa = {
  dependencies: [A.ListNode, A.ListItemNode],
  export: function _export(a, b) {
    return A.$isListNode(a) ? Y(a, b, 0) : null;
  },
  regExp: /^(\s*)(\d{1,})\.\s/,
  replace: X("number"),
  type: "element"
},
    ra = {
  format: ["code"],
  tag: "`",
  type: "text-format"
},
    sa = {
  format: ["highlight"],
  tag: "==",
  type: "text-format"
},
    ta = {
  format: ["bold", "italic"],
  tag: "***",
  type: "text-format"
},
    va = {
  format: ["bold", "italic"],
  intraword: !1,
  tag: "___",
  type: "text-format"
},
    wa = {
  format: ["bold"],
  tag: "**",
  type: "text-format"
},
    xa = {
  format: ["bold"],
  intraword: !1,
  tag: "__",
  type: "text-format"
},
    ya = {
  format: ["strikethrough"],
  tag: "~~",
  type: "text-format"
},
    za = {
  format: ["italic"],
  tag: "*",
  type: "text-format"
},
    Aa = {
  format: ["italic"],
  intraword: !1,
  tag: "_",
  type: "text-format"
},
    Ba = {
  dependencies: [G.LinkNode],
  export: function _export(a, b, c) {
    if (!G.$isLinkNode(a)) return null;
    b = (b = a.getTitle()) ? "[".concat(a.getTextContent(), "](").concat(a.getURL(), " \"").concat(b, "\")") : "[".concat(a.getTextContent(), "](").concat(a.getURL(), ")");
    var d = a.getFirstChild();
    return 1 === a.getChildrenSize() && k.$isTextNode(d) ? c(d, b) : b;
  },
  importRegExp: /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))/,
  regExp: /(?:\[([^[]+)\])(?:\((?:([^()\s]+)(?:\s"((?:[^"]*\\")*[^"]*)"\s*)?)\))$/,
  replace: function replace(a, b) {
    var _b = b,
        _b2 = _slicedToArray(_b, 4),
        c = _b2[1],
        d = _b2[2],
        e = _b2[3];

    b = G.$createLinkNode(d, {
      title: e
    });
    var f = k.$createTextNode(c);
    f.setFormat(a.getFormat());
    b.append(f);
    a.replace(b);
  },
  trigger: ")",
  type: "text-match"
},
    Ca = [la, ma, na, oa, qa],
    Da = [ra, ta, va, wa, xa, sa, za, Aa, ya],
    Ea = [Ba],
    Z = [].concat(Ca, Da, Ea);

exports.$convertFromMarkdownString = function (a) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Z;
  var c = arguments.length > 2 ? arguments[2] : undefined;
  return ha(b)(a, c);
};

exports.$convertToMarkdownString = function () {
  var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : Z;
  var b = arguments.length > 1 ? arguments[1] : undefined;
  return ba(a)(b);
};

exports.BOLD_ITALIC_STAR = ta;
exports.BOLD_ITALIC_UNDERSCORE = va;
exports.BOLD_STAR = wa;
exports.BOLD_UNDERSCORE = xa;
exports.CHECK_LIST = pa;
exports.CODE = na;
exports.ELEMENT_TRANSFORMERS = Ca;
exports.HEADING = la;
exports.HIGHLIGHT = sa;
exports.INLINE_CODE = ra;
exports.ITALIC_STAR = za;
exports.ITALIC_UNDERSCORE = Aa;
exports.LINK = Ba;
exports.ORDERED_LIST = qa;
exports.QUOTE = ma;
exports.STRIKETHROUGH = ya;
exports.TEXT_FORMAT_TRANSFORMERS = Da;
exports.TEXT_MATCH_TRANSFORMERS = Ea;
exports.TRANSFORMERS = Z;
exports.UNORDERED_LIST = oa;

exports.registerMarkdownShortcuts = function (a) {
  var b = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Z;
  var c = I(b),
      d = H(c.textFormat, function (_ref3) {
    var f = _ref3.tag;
    return f[f.length - 1];
  }),
      e = H(c.textMatch, function (_ref4) {
    var f = _ref4.trigger;
    return f;
  });

  var _iterator15 = _createForOfIteratorHelper(b),
      _step15;

  try {
    for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
      var f = _step15.value;

      if (b = f.type, "element" === b || "text-match" === b) {
        b = f.dependencies;

        var _iterator21 = _createForOfIteratorHelper(b),
            _step21;

        try {
          for (_iterator21.s(); !(_step21 = _iterator21.n()).done;) {
            var g = _step21.value;
            if (!a.hasNode(g)) throw Error("MarkdownShortcuts: missing dependency ".concat(g.getType(), " for transformer. Ensure node dependency is included in editor initial config."));
          }
        } catch (err) {
          _iterator21.e(err);
        } finally {
          _iterator21.f();
        }
      }
    }
  } catch (err) {
    _iterator15.e(err);
  } finally {
    _iterator15.f();
  }

  return a.registerUpdateListener(function (_ref5) {
    var f = _ref5.tags,
        g = _ref5.dirtyLeaves,
        l = _ref5.editorState,
        p = _ref5.prevEditorState;

    if (!f.has("historic") && !a.isComposing()) {
      var r = l.read(k.$getSelection);
      f = p.read(k.$getSelection);

      if (k.$isRangeSelection(f) && k.$isRangeSelection(r) && r.isCollapsed()) {
        p = r.anchor.key;

        var y = r.anchor.offset,
            q = l._nodeMap.get(p);

        !k.$isTextNode(q) || !g.has(p) || 1 !== y && y > f.anchor.offset + 1 || a.update(function () {
          if (!q.hasFormat("code")) {
            var m = q.getParent();

            if (null !== m && !t.$isCodeNode(m)) {
              var w = r.anchor.offset;

              b: {
                var h = c.element,
                    n = m.getParent();

                if (k.$isRootOrShadowRoot(n) && m.getFirstChild() === q && (n = q.getTextContent(), " " === n[w - 1])) {
                  var _iterator16 = _createForOfIteratorHelper(h),
                      _step16;

                  try {
                    for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                      var _ref7 = _step16.value;
                      var D = _ref7.regExp;
                      var E = _ref7.replace;

                      if ((h = n.match(D)) && h[0].length === w) {
                        n = q.getNextSiblings();

                        var _q$splitText = q.splitText(w),
                            _q$splitText2 = _slicedToArray(_q$splitText, 2),
                            F = _q$splitText2[0],
                            ua = _q$splitText2[1];

                        F.remove();
                        n = ua ? [ua].concat(_toConsumableArray(n)) : n;
                        E(m, n, h, !1);
                        m = !0;
                        break b;
                      }
                    }
                  } catch (err) {
                    _iterator16.e(err);
                  } finally {
                    _iterator16.f();
                  }
                }

                m = !1;
              }

              if (!m) {
                b: {
                  h = q.getTextContent();
                  m = e[h[w - 1]];

                  if (null != m) {
                    w < h.length && (h = h.slice(0, w));

                    var _iterator17 = _createForOfIteratorHelper(m),
                        _step17;

                    try {
                      for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                        x = _step17.value;

                        if (m = h.match(x.regExp), null !== m) {
                          var _q$splitText3, _q$splitText4, _q$splitText5, _q$splitText6;

                          h = m.index || 0;
                          n = h + m[0].length;
                          var v = void 0;
                          0 === h ? (_q$splitText3 = q.splitText(n), _q$splitText4 = _slicedToArray(_q$splitText3, 1), v = _q$splitText4[0], _q$splitText3) : (_q$splitText5 = q.splitText(h, n), _q$splitText6 = _slicedToArray(_q$splitText5, 2), v = _q$splitText6[1], _q$splitText5);
                          v.selectNext(0, 0);
                          x.replace(v, m);
                          var x = !0;
                          break b;
                        }
                      }
                    } catch (err) {
                      _iterator17.e(err);
                    } finally {
                      _iterator17.f();
                    }
                  }

                  x = !1;
                }

                if (!x) b: {
                  n = q.getTextContent();
                  --w;
                  var u = n[w];

                  if (x = d[u]) {
                    var _iterator18 = _createForOfIteratorHelper(x),
                        _step18;

                    try {
                      for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                        var _D = _step18.value;
                        var C = _D.tag;
                        x = C.length;

                        var _E = w - x + 1;

                        if (!(1 < x && !W(n, _E, C, 0, x) || " " === n[_E - 1]) && (v = n[w + 1], !1 !== _D.intraword || !v || J.test(v))) {
                          m = v = q;
                          h = V(n, _E, C);

                          for (var z = m; 0 > h && (z = z.getPreviousSibling()) && !k.$isLineBreakNode(z);) {
                            k.$isTextNode(z) && (h = z.getTextContent(), m = z, h = V(h, h.length, C));
                          }

                          if (!(0 > h || m === v && h + x === _E || (C = m.getTextContent(), 0 < h && C[h - 1] === u || (z = C[h - 1], !1 === _D.intraword && z && !J.test(z))))) {
                            n = v.getTextContent();
                            n = n.slice(0, _E) + n.slice(w + 1);
                            v.setTextContent(n);
                            n = m === v ? n : C;
                            m.setTextContent(n.slice(0, h) + n.slice(h + x));
                            n = k.$getSelection();
                            u = k.$createRangeSelection();
                            k.$setSelection(u);
                            w = w - x * (m === v ? 2 : 1) + 1;
                            u.anchor.set(m.__key, h, "text");
                            u.focus.set(v.__key, w, "text");

                            var _iterator19 = _createForOfIteratorHelper(_D.format),
                                _step19;

                            try {
                              for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
                                var _F = _step19.value;
                                u.hasFormat(_F) || u.formatText(_F);
                              }
                            } catch (err) {
                              _iterator19.e(err);
                            } finally {
                              _iterator19.f();
                            }

                            u.anchor.set(u.focus.key, u.focus.offset, u.focus.type);

                            var _iterator20 = _createForOfIteratorHelper(_D.format),
                                _step20;

                            try {
                              for (_iterator20.s(); !(_step20 = _iterator20.n()).done;) {
                                var _F2 = _step20.value;
                                u.hasFormat(_F2) && u.toggleFormat(_F2);
                              }
                            } catch (err) {
                              _iterator20.e(err);
                            } finally {
                              _iterator20.f();
                            }

                            k.$isRangeSelection(n) && (u.format = n.format);
                            break b;
                          }
                        }
                      }
                    } catch (err) {
                      _iterator18.e(err);
                    } finally {
                      _iterator18.f();
                    }
                  }
                }
              }
            }
          }
        });
      }
    }
  });
};